

import * as React from "react";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useSearchParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import OrdersDetails from "./ordersDetails";
import {
  Button,
  IconButton,
} from "@mui/material";
import { AddOutlined, RemoveOutlined } from "@mui/icons-material";
import { t } from "i18next";
import {
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileTextColor,
  getLocalStorageMenuItem,
} from "../../../utility";

const drawerBleeding = 56;

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor:
    theme.palette.mode === "light"
      ? grey[100]
      : theme.palette.background.default,
}));

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const Puller = styled("div")(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
}));

const OrderItem = (props) => {
  const { isDesktop, isTablet, item, currency, selected, handleOpenToast } = props;
  const [params, setParams] = useSearchParams();
  const [qty, setQty] = React.useState(1);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const divRef = React.useRef(null);

  const toggleDrawer = (status) => () => {
    if (status) {
      props.handleOrder(true);
    } else {
      props.handleOrder(false);
    }
  };


  return (
    <Box sx={{ display: props.open ? "block" : "none" }}>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: divRef.current
              ? divRef.current.offsetWidth
              : `calc(60% - ${drawerBleeding}px)`,
            overflow: "visible",
            width: props.container.current?.offsetWidth,
            marginRight: fullScreen ? 0 : "14px",
            backgroundColor: "#111",
          },
        }}
      />

      <SwipeableDrawer
        anchor="bottom"
        open={props.open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          sx={{
            position: "absolute",
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: props.open ? "visible" : "hidden",
            right: 0,
            left: 0,
            backgroundColor: setMobileBackColor(),
          }}
        >
          <Puller sx={{ backgroundColor: setMobileButttonBackColor() }} />
          <Typography
            className="alignByLang"
            sx={{ p: 2, color: "text.secondary", visibility: "visible" }}
          >
            <span style={{ visibility: "hidden" }}>result</span>
          </Typography>
        </StyledBox>
        <StyledBox
          sx={{
            px: 2,
            pb: 2,
            height: "100%",
            overflow: "auto",
            backgroundColor: setMobileBackColor(),
          }}
          ref={divRef}
        >
          <OrdersDetails {...props} />
        </StyledBox>
      </SwipeableDrawer>
    </Box>
  );
};

export default OrderItem;